import { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { Flex, Stack } from "@chakra-ui/react";
import { ArrowLeftIcon, Container, NextLink } from "@looksrare/uikit";
import { useTranslation } from "next-i18next";
import { Button } from "uikit";
import { UnclaimedWinnings } from "views/win/userGeneratedRaffles/components/UnclaimedWinnings";
import { HistoryTable } from "views/win/userGeneratedRaffles/components/HistoryTable/HistoryTable";
import { FilterButton } from "views/win/userGeneratedRaffles/components/RafflesGrid/FilterButton";
import {
  useCommunityRafflesFilter,
  useFilterOptions,
} from "views/win/userGeneratedRaffles/components/RafflesGrid/utils";
import { RAFFLE_HISTORY_PER_PAGE, useRafflesHistory } from "views/win/userGeneratedRaffles/utils/hooks";

export const RafflesHistoryView = () => {
  const { t } = useTranslation();
  const { address } = useAccount();
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const offset = (currentPageNumber - 1) * RAFFLE_HISTORY_PER_PAGE;
  const filterOptions = useFilterOptions();

  const { filter, selectedOption, setSelectedOption } = useCommunityRafflesFilter();

  const { data: rafflesHistoryData } = useRafflesHistory({
    pagination: {
      offset,
      first: RAFFLE_HISTORY_PER_PAGE,
    },
    connectedUser: address,
    filter,
  });
  const { raffles = [], total = 0 } = rafflesHistoryData || {};
  // total becomes undefined when the user changes pages.
  const [safeTotal, setSafeTotal] = useState(total);
  useEffect(() => {
    if (typeof total === "undefined" || total === safeTotal) {
      return;
    }
    setSafeTotal(total);
  }, [safeTotal, total]);

  return (
    <Container maxWidth="1440px" py={8}>
      <Stack spacing={4}>
        {/* Header */}
        <Flex
          flexDirection={{ base: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ base: "flex-start", md: "center" }}
          gap={4}
        >
          <Button as={NextLink} href="/raffles" leftIcon={<ArrowLeftIcon />} variant="ghost" size="md">
            {t("Raffles")}
          </Button>
          <UnclaimedWinnings width={{ base: "100%", md: "512px" }} />
        </Flex>
        {/* Filters */}
        <Flex justifyContent="flex-end" alignItems="center">
          <FilterButton onSelect={setSelectedOption} options={filterOptions} selectedOption={selectedOption} />
        </Flex>
        {/* Table */}
        <HistoryTable page={currentPageNumber} setPage={setCurrentPageNumber} totalRows={safeTotal} raffles={raffles} />
      </Stack>
    </Container>
  );
};
